<template>
  <!--产品列表 -->
  <transition name="el-fade-in-linear">
    <div class="divliebiao" v-show="dialogFormVisible">
      <div :class="divliebiaoright">
        <div class="listhead">
          <div class="listtitle">查询结果</div>
          <div class="closed"><i class="el-icon-close" @click="closed"></i></div>
        </div>
        <div class="listbody">
          <div class="listcheckall" style="padding-right: 40px;">
            <el-checkbox v-model="checked" @change="call">
              <span>{{dynamicTags.length>0 ? $route.path === '/remoteSenseData' ? dynamicTags[0].productDescription : dynamicTags[0].product_description:""}}</span>
            </el-checkbox>
            <i class="el-icon-thirdcart" v-if="isshow" @click="selectaddall(1,$event)"></i>
          </div>
          <div class="gundong">
            <div ref="gundong" id="gundong">
              <div class="listcheckbody" v-for="item in dynamicTags"
                :key="$route.path === '/remoteSenseData' ? item.imageId : item.product_id"
                :id="$route.path === '/remoteSenseData' ? item.imageId : item.product_id" :layerurl="item.tile_url"
                :resolution="$route.path === '/remoteSenseData' ? item.spatialResolution : item.spatial_resolution"
                style="margin-top: 5px;">
                <el-checkbox v-model="item.checkall" v-if="$route.path === '/remoteSenseData'" id="showName"
                  @change="zicheck(item.checkall)" :style="dataStyle">
                  <i v-if="$route.path === '/remoteSenseData'" :class="iconForShow(item.status)"></i>
                  <!-- <i v-if="$route.path === '/remoteSenseData'" :class="item.filePath ? dataicon : datanicon"></i> -->
                  <!-- {{$route.path === '/remoteSenseData' ? item.productName : item.product_date}} -->
                  <span class="nameShow" :title="nameForShow(item)">{{nameForShow(item)}}</span>
                </el-checkbox>
                <el-checkbox v-model="item.checkall" @change="zicheck(item.checkall)" :style="dataStyle" v-else>
                  <i v-if="$route.path === '/remoteSenseData'" :class="iconForShow(item.status)"></i>
                  <span class="nameShow" :title="nameForShow(item)">{{nameForShow(item)}}</span>
                </el-checkbox>
                <i class="el-icon-thirdinformation" @click="selectinfo(item,$event)"></i>
                <i class="el-icon-thirdcart" @click="selectinfoadd(item,$event)"></i>
                <!-- :style="{color: item['itemColor'+ item.product_id]}" -->
                <i class="el-icon-thirdlisting-content" @click="selectinfoshow(item,$event)"></i>
              </div>

            </div>
            <div class="more" @click="moread" v-if="moreisvds"
              v-show="dynamicTags.length===50 || dynamicTags.length>50">
              <div class='item-slider-domains'></div>
              <div class='item-slider-opacitys'></div>
              [[ 点击加载更多 ]]
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import Map from '../../common/map/Tmap.js'
import olGeoTiff from '../../common/map/olGeoTiff_07.js'
import eventBus from '../../common/eventBus.js'
import store from '../../vuex/index.js'
export default {
  name: 'HeadProductListDialog',
  props: ['msgFather', 'prodata', 'cartdatas', 'tcdatas',
    'moreisvds', 'queryType', 'range', 'regionname', 'cityId'],
  data () {
    return {
      dialogFormVisible: false,
      divliebiaoright: 'divliebiaoright',
      dynamicTags: [],
      productdata: {},
      isshow: false,
      checked: false,
      gwc: [],
      tc: [],
      dataStyle: '',
      dataicon: 'dataicon',
      datanicon: 'datanicon',
      datazicon: 'datazicon',
      visadd: '',
      moreis: true
    }
  },
  created: function () {
    this.dynamicTags = this.prodata
    this.visadd = this.visedadd
    this.gwc = this.cartdatas
    this.tc = this.tcdatas
    this.moreis = this.moreisvds
    this.dialogFormVisible = this.msgFather
    this.onLogin()
    this.onLogout()
    if (this.$route.path === '/remoteSenseData') {
      this.divliebiaoright = 'divdataliebiaoright'
    } else {
      this.divliebiaoright = 'divliebiaoright'
    }
  },
  methods: {
    iconForShow (status) {
      if (status === '000') {
        return this.datanicon
      } else if (status === '009') {
        return this.dataicon
      } else {
        return this.datazicon
      }
    },
    nameForShow (item) {
      let name = ''
      if (this.$route.path === '/remoteSenseData') {
        if (item.catalogCode === '36410020060196005020100' || item.catalogCode === '20320050010016014070100' || item.catalogCode === '20460050020016015070100') {
          name = item.productName.substring(0, 63)
        } else {
          name = item.productName
        }
      } else {
        store.commit('setLoading', false)
        name = item.product_date
      }
      return name
    },
    moread: function () {
      store.commit('setLoading', true)
      this.$emit('moreadd', {})
    },
    onLogin () {
      const that = this
      eventBus.$on('cartInfo', cartInfo => {
        if (cartInfo.cartItems.length > 0) {
          that.gwc = []
          cartInfo.cartItems.forEach(cartInfo => {
            that.gwc.push(cartInfo)
          })
        }
      })
    },
    onLogout () {
      const that = this
      eventBus.$on('clearCart', cartInfo => {
        that.gwc = []
      })
    },
    zicheck: function (val) {
      var ck = true
      this.isshow = false
      this.dynamicTags.forEach(el => {
        if (el.checkall) {
          this.isshow = true
        } else {
          ck = false
        }
      })
      this.checked = ck
    },
    call: function () {
      if (this.checked) {
        this.dynamicTags.forEach(el => {
          el.checkall = true
          this.isshow = true
        })
      } else {
        this.dynamicTags.forEach(el => {
          el.checkall = false
          this.isshow = false
        })
      }
    },
    selectaddall: function (val, e) {
      this.visadd = Map.GetDrawPolygonWKT(this.dynamicTags[0].spatial_resolution)
      if (this.visadd === '') {
        this.$message({
          message: '请选择所需范围 ！',
          type: 'warning'
        })
        return
      }
      var pto = []
      // 当前购物车选中的数据处理方法
      if (this.checked) {
        this.dynamicTags.forEach((el, index) => {
          if (el.checkall) {
            pto.push(el)
          }
        })
        // 当前购物车全选数据处理方法
      } else {
        this.dynamicTags.forEach((el, index) => {
          if (el.checkall) {
            pto.push(el)
          }
        })
      }
      var pids = []
      /* eslint-disable */
      var geoinfo = ''
      var addcartinfos = []
      pto.forEach((el, index) => {
        el.webgeo = this.visadd
        addcartinfos.push(el)
        // this.gwc.push(el)
        if (this.$route.path === '/remoteSenseData') {
          pids.push(el.imageId)
        } else {
          pids.push(el.product_id)
        }
        geoinfo = el.webgeo
      })
      // 调用添加购物车方法
      this.addBasket(pids, addcartinfos, geoinfo)
    },
    // 添加购物车方法 pids:产品标识数组 addcartinfos:待添加的购物车信息 geoinfo:区域geometry
    addBasket (pids, addcartinfos, geoinfo) {
      var cartdata = {
        'product_geometry_json': JSON.stringify({
          'product_id_arr': pids,
          'geometry': geoinfo,
          'type': this.$route.path === '/remoteSenseData' ? '1' : '0'
        })
      }
      //查询选中区域的价格
      this.sapost('/dmc/cart/Price', cartdata, r => {
        let prices = r.data

        // 校验用户是否登录
        // 是否登录标识
        var isLogin = false
        this.sapost('/dmc/cart/checkLogin', '', r => {
          let result = r.data
          if (result.islogin === 1) {
            isLogin = true
          }
          var _this = this
          var qType = localStorage.getItem('queryType')
          //调用添加购物车接口
          // 已登录
          if (isLogin) {
            let user = {
              userId: '',
              userName: '',
              nickName: ''
            }
            user = JSON.parse(sessionStorage.getItem('user'))
            var cartData1Arr = []
            addcartinfos.forEach((cartInfo, index) => {
              var productID = this.$route.path === '/remoteSenseData' ? cartInfo.imageId * 1 : cartInfo.product_id * 1
               let priceItem = {
                  product_id: productID,
                  custom_price: 1,
                  custom_area: 1
               }
              if (prices !== "") {
                priceItem = prices.find(item => item.product_id * 1 === productID * 1)  
              }
              var cartData = {
                'productID': productID,
                'productName': _this.$route.path === '/remoteSenseData' ? cartInfo.productName : cartInfo.product_name,
                "amountOfPay": priceItem.custom_price,
                "area": priceItem.custom_area
              }
              cartData1Arr.push(cartData)
            })
            var cartdata1 = {
              'product_geometry_json': JSON.stringify({
                'dataArr': cartData1Arr,
                'area_of_interest': _this.range == 'custom' ? geoinfo : '',
                'range': _this.range,
                'gid': _this.range == 'custom' ? '' : _this.cityId + '',
                'region': _this.range == 'custom' ? '' : _this.regionname
              })
            }
            let data = {
              'customerid': user.userId,
              'querytype': this.$route.path === '/remoteSenseData' ? '2' : qType,
              'op': 'add',
              'carttype': _this.$route.path === '/remoteSenseData' ? 0 : 1,
              'product_geometry_json': cartdata1.product_geometry_json
            }
            this.sapost('/dmc/cart/cartoperation', data, r => {
              var cartInfos = r.data
              if (cartInfos === -1) {
                this.$message.warning('添加购物车记录重复，请重新选择！')
                return
              } else {
                cartInfos.forEach((cartInfo, index) => {
                  _this.gwc.push(cartInfo)
                })
                this.$message.success('购物车添加成功！')
              }
              this.sendcartlist()
            })
            // 未登录
          } else {
            let sessionDataArr = []
            addcartinfos.forEach((cartInfo, index) => {
              let productID = _this.$route.path === '/remoteSenseData' ? cartInfo.imageId : cartInfo.product_id
              let priceItem = prices.find(item => item.product_id * 1 === productID * 1)
              let p = {
                'product_name': _this.$route.path === '/remoteSenseData' ? cartInfo.productName : cartInfo.product_name,
                'productID': productID,
                'product_date': _this.$route.path === '/remoteSenseData' ? cartInfo.productDate : cartInfo.product_date,
                'queryType': this.$route.path === '/remoteSenseData' ? '2' : qType,
                'area': priceItem.custom_price,
                'amountOfPay': priceItem.custom_price,
                'is_selected': false,
                'area_of_interest': _this.$route.path === '/remoteSenseData' ? geoinfo : _this.range == 'custom' ? geoinfo : '',
                'range': _this.range,
                'gid': _this.range == 'custom' ? '' : _this.cityId,
                'region': _this.range == 'custom' ? '' : _this.regionname,
                'cart_type': _this.$route.path === '/remoteSenseData' ? '0' : '1'
              }
              sessionDataArr.push(p)
            })
            let sessiondata = {
              "product_geometry_json": JSON.stringify(sessionDataArr)
            }
            let addCartInfo = {
              'op': 'addcart',
              'message': sessiondata.product_geometry_json
            }
            //fixme promise
            this.sapost('/dmc/cart/session', addCartInfo, r => {
              var cartInfos = JSON.parse(r.data.message)
              if (cartInfos === -1) {
                this.$message.warning('添加购物车记录重复，请重新选择！')
              } else {
                cartInfos.forEach((cartInfo, index) => {
                  _this.gwc.push(cartInfo)
                })
                this.$message.success('购物车添加成功！')
              }
              this.sendcartlist()
            })
          }
        })
      })
    },
    addtu: function (val) {
      if (!val.tccheckall) {
        return
      }
      var name = 'Layer' + val.product_id

      if (val.tile_image_type && val.tile_image_type.toLowerCase() === 'png') {
        console.log('第一个')
        Map.LoadMuiltBandByXYZ(val)
      } else if (val.data_format.toLowerCase() === 'shp') {
        var obj = []
        var josndata = {
          product_id: val.product_id,
          satellite_id: val.satellite_id
        }
        this.sapost('/dmc/manage/standardProduct/getFirePointsInfo', josndata, r => {
          obj = r.data
          Map.addLayerforpoint(Map.getFireLayer(obj, name))
        })
      } else {
        console.log('第三个')
        if (Map.LoadSingleBandByXYZ(val)) {
          // eslint-disable-next-line
          var geoTiff = new olGeoTiff(Map.GetLayerByName("Layer" + val.product_id));
          console.log(geoTiff)
          var Maxvalue = parseFloat(val.max_value)
          var Minvalue = parseFloat(val.min_value)
          geoTiff.plotOptions.domain = [Minvalue, Maxvalue]
          geoTiff.plotOptions.noDataValue = val.no_data_value
          Map.geoTiffs.push({
            'geoTiff': geoTiff,
            'name': 'Layer' + val.product_id
          })
        }
      }
    },
    selectinfoshow: function (val, e) {
      if (this.$route.path === '/remoteSenseData') {
        var ps = e.currentTarget.parentNode.parentNode.getElementsByTagName('div')
        if (e.currentTarget.style.color === 'rgb(24, 188, 156)') {
          e.currentTarget.style.color = '#ccc'
          Map.AddImage(val.geometry, '', '', val.imageId, '')
        } else {
          if (val.quickView == 0) {
            Map.AddWKTs2Source(val.geometry, true, 'data', false)
          } else {
            var extent = [val.upperLeftLong, val.lowerRightLat, val.lowerRightLong, val.upperLeftLat]
            var url = this.$root.URL + '/' + val.quickView
            Map.AddImage(val.geometry, extent, url, val.imageId, 'quick')
          }
          for (var i = 0; i < ps.length; i++) {
            ps[i].getElementsByTagName('i')[0].style.color = '#ccc'
          }
          e.currentTarget.style.color = '#18bc9c'
        }
      } else {
        if (e.currentTarget.style.color === 'rgb(24, 188, 156)') {
          e.currentTarget.style.color = '#ccc'
          var name = 'Layer' + val.product_id
          Map.RemoveLayerByName(name)
          this.tc.forEach((item, index) => {
            if (item.product_id === val.product_id) {
              this.tc.splice(index, 1)
            }
          })
          this.sendtclist()
        } else {
          e.currentTarget.style.color = '#18bc9c'
          val.tccheckall = true
          this.tc.unshift(val)
          this.addtu(val)
          this.sendtclist()
        }
      }
    },
    selectinfoadd: function (val, e) {
      //添加购物车
      //用户选中的区域
      if (this.$route.path === '/remoteSenseData') {
        this.visadd = val.geometry
      } else {
        this.visadd = Map.GetDrawPolygonWKT(val.spatial_resolution)
        // var name = 'Layer' + val.product_id
        // Map.RemoveLayerByName(name)
        // val['itemColor' + val.product_id] = '#ccc'
        // this.tc.forEach((item, index) => {
        //   if (item.product_id === val.product_id) {
        //     this.tc.splice(index, 1)
        //   }
        // })
        // this.sendtclist()
      }
      if (this.visadd === '') {
        this.$message({
          message: '请选择所需范围 ！',
          type: 'warning'
        })
        return
      }
      var _this = this
      val.webgeo = this.visadd
      // 调用添加购物车方法
      if (_this.$route.path === '/remoteSenseData') {
        this.addBasket([val.imageId], [val], val.webgeo)
      } else {
        this.addBasket([val.product_id], [val], val.webgeo)
      }
    },
    selectinfo: function (val, e) {
      var hob = {}
      hob.msg = true
      var ps = e.currentTarget.parentNode.parentNode.getElementsByTagName('div')
      if (e.currentTarget.style.color === 'rgb(24, 188, 156)') {
        e.currentTarget.style.color = '#ccc'
        hob.msg = false
      } else {
        for (var i = 0; i < ps.length; i++) {
          ps[i].getElementsByTagName('i')[0].style.color = '#ccc'
        }
        e.currentTarget.style.color = '#18bc9c'
        hob.msg = true
        if (val.quickView !== '0') {
          val.quickViewUrl = window.location.origin + "/" + val.quickView
        }
      }
      hob.data = val
      this.$emit('getselectinfovisible', hob)
    },
    sendcartlist: function () {
      this.$emit('getcartlist', this.gwc)
    },
    sendtclist: function () {
      this.$emit('gettclist', this.tc)
    },
    sendMsgToParent: function () {
      this.$emit('getproductdialogFormVisible', this.dialogFormVisible)
    },
    closed: function (e) {
      this.dialogFormVisible = false
      var hob = e.currentTarget.parentNode.parentNode.parentNode.lastChild.lastChild.getElementsByTagName('i')
      for (var i = 0; i < hob.length; i++) {
        hob[i].style.color = '#ccc'
      }
      this.checked = false
      this.isshow = false
    }
  },
  watch: {
    $route (val) {
      if (val.path === '/remoteSenseData') {
        this.divliebiaoright = 'divdataliebiaoright'
        this.dataStyle = 'width:500px'
      } else {
        this.divliebiaoright = 'divliebiaoright'
        this.dataStyle = ''
      }
    },
    dynamicTags (val) {
      if (val.length === 0) {
        this.dialogFormVisible = false
      } else {
        this.dialogFormVisible = true
      }
    },
    msgFather: function (curVal) {
      console.log(curVal)
      this.dialogFormVisible = curVal
      var arr = this.$refs.gundong.childNodes
      if (curVal) {
        this.tc.forEach(el => {
        })
      }
    },
    dialogFormVisible: function () {
      this.sendMsgToParent()
    },
    prodata: function (data) {
      this.dynamicTags = data
    },
    visedadd: function (data) {
      this.visadd = data
    },
    moreisvds: function (data) {
      this.moreis = data
    },
    tcdatas: function (data) {
      console.log('检测到图层变化')
      this.tc = data
      var arr = this.$refs.gundong.childNodes
      // for (var i = 0; i < arr.length; i++) {
      //   arr[i].getElementsByTagName('i')[2].style.color = '#ccc'
      // }
      // this.tc.forEach(el => {

      //   for (var ii = 0; ii < arr.length; ii++) {
      //     if (arr[ii].id === el.product_id) {
      //       arr[ii].getElementsByTagName('i')[2].style.color = '#18bc9c'
      //     }
      //   }
      // })
    },
    cartdatas: function (data) {
      console.log('监听到购物车数据变化')
      var arr = this.$refs.gundong.childNodes
      console.log(arr.length)
      for (var i = 0; i < arr.length; i++) {
        arr[i].getElementsByTagName('i')[1].style.color = '#ccc'
      }
      if (data.length > 0) {
        console.log('监听到购物车数据大于1变化')
        for (var ii = 0; ii < arr.length; ii++) {
          data.forEach(ec => {
            if (ec.product_id === arr[ii].id) {
              console.log(arr[ii].getElementsByTagName('i')[1])
              arr[ii].getElementsByTagName('i')[1].style.color = '#18bc9c'
              this.dynamicTags.forEach(ed => {
                if (ed.product_id === ec.id) {
                  ed.cartcheckall = false
                }
              })
            }
          })
        }
        // })
      } else {
        console.log('监听到购物车数据清空变化')
        for (var iii = 0; iii < arr.length; iii++) {
          arr[iii].getElementsByTagName('i')[1].style.color = '#ccc'
        }
        this.checked = false
        this.call()
        this.dynamicTags.forEach(ed => {
          ed.cartcheckall = false
        })
      }
      this.gwc = data
    }
  }
}
</script >
<style>
.more {
  font-size: 12px;
  color: #ccc;
  cursor: pointer;
  margin-top: 10px;
}
.more:hover {
  font-size: 12px;
  color: rgb(24, 188, 156);
  cursor: pointer;
  margin-top: 10px;
}
::-webkit-scrollbar {
  width: 4px;
}
::-webkit-scrollbar-track {
  background-color: #fff;
}
::-webkit-scrollbar-thumb {
  background-color: #18bc9c;
}
::-webkit-scrollbar-thumb:hover {
  background-color: #18bc9c;
}
::-webkit-scrollbar-thumb:active {
  background-color: #18bc9c;
}
.gundong {
  overflow-y: auto;
  overflow-x: hidden;
  height: 94%;
}
.listcheckall {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding-left: 20px;
  padding-right: 48px;
  padding-top: 10px;
}
.listcheckall i {
  margin-top: 0px;
  color: #18bc9c;
  cursor: pointer;
}
.listcheckbody {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding-left: 20px;
  padding-right: 12px;
}
.listcheckbody i {
  margin-top: 0px;
  color: #ccc;
  cursor: pointer;
}
.listcheckbody i:hover {
  margin-top: 0px;
  color: #18bc9c;
  cursor: pointer;
}
.is_active {
  margin-top: 5px;
  color: #18bc9c;
  cursor: pointer;
}
.listbody {
  height: 94%;
}
.listhead {
  display: flex;
  background-color: #191b2e;
  height: 20px;
  padding: 10px;
  justify-content: space-between;
  color: #fff;
  font-size: 14px;
}
.divliebiao {
  background-color: #191b2e;
  width: 300px;
  height: 100%;
  margin-left: 53px;
}
.divliebiaoright {
  width: 300px;
  height: 100%;
  background-color: #fff;
}
.divdataliebiaoright {
  width: 670px;
  height: 100%;
  background-color: #fff;
}
.dataicon {
  display: inline-block;
  height: 12px;
  width: 12px;
  background: url("../../assets/img/dataGreen.png") no-repeat center;
  background-size: 100%;
  vertical-align: middle;
}
.datanicon {
  display: inline-block;
  height: 13px;
  width: 13px;
  background: url("../../assets/img/dataGery.png") no-repeat center;
  background-size: 100%;
  vertical-align: middle;
}
.datazicon {
  display: inline-block;
  height: 12px;
  width: 12px;
  background: url("../../assets/img/dataLoading.png") no-repeat center;
  background-size: 100%;
  vertical-align: middle;
}
.nameShow {
  display: inline-block;
  vertical-align: middle;
  width: 95%;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
}
#showName {
  width: 80%;
  left: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/LeftMenu/HeadProductListDialog.vue